module.exports = __webpack_public_path__ + "img/Docs Icon.8b44d6eb.svg";